import React from 'react'
import { Outlet } from 'react-router-dom'
import HeaderServices from '../components/layout/HeaderServices'
import { useEffect } from 'react';
import watsIcon from '../assest/home/5357b4eb16238760df0ba166628f1cee41086e44.png';
import styles from '../css/headerServices.module.css'
import { Link, useLocation } from 'react-router-dom';
import data from '../data/data'
function ServicesOf() {
  useEffect(() => {
    const isMobile = window.innerWidth <= 768;
    if (isMobile) {
      window.scrollTo(0, 0);
    }
    else {
      const middleOfPage = document.documentElement.scrollHeight / 6;
      window.scrollTo({
        top: middleOfPage,
        behavior: 'smooth'
      });
    }
  }, []);
  //=================================
  let index = -1;
  const location = useLocation();
  switch (location.pathname) {
    case '/services/TrainQualif':
      index = 0;
      break;
    case '/services/medicalservices':
      index = 1;
      break;
    case '/services/saberservices':
      index = 2;
      break;
    case '/services/najizServices':
      index = 3;
      break;
    case '/services/madad':
      index = 4;
      break;
    case '/services':
      index = 5;
      break;
    case '/services/professionallicense':
      index = 6;
      break;
    case '/services/agriculturallicense':
      index = 7;
      break;
    case '/services/forecommlice':
      index = 8;
      break;
    case '/services/coiLissauPar':
      index = 9;
      break;
    case '/services/proflicesapartner':
      index = 10;
      break;
    case '/services/transactivlice':
      index = 11;
      break;
    case '/services/prolic':
      index = 12;
      break;
    case '/services/indlic':
      index = 13;
      break;
    case '/services/invbizres':
      index = 14;
      break;
    case '/services/unires':
      index = 15;
      break;
    case '/services/entres':
      index = 16;
      break;
    case '/services/proownres':
      index = 17;
      break;
    case '/services/talres':
      index = 18;
      break;
    case '/services/excepres':
      index = 19;
      break;
    case '/services/manorgevCon':
      index = 20;
      break;
    case '/services/actTabtam':
      index = 21;
      break;
    case '/services/devweb':
      index = 22;
      break;
    case '/services/upmap':
      index = 23;
      break;
    case '/services/raibra':
      index = 24;
      break;
    case '/services/manorgEst':
      index = 25;
      break;
    case '/services/mansocacc':
      index = 26;
      break;
    case '/services/propho':
      index = 27;
      break;
    case '/services/booAccrec':
      index = 28;
      break;
    case '/services/settraacc':
      index = 29;
      break;
    case '/services/accsysper':
      index = 30;
      break;
    case '/services/warinvman':
      index = 31;
      break;
    case '/services/proacccon':
      index = 32;
      break;
    case '/services/proaccsys':
      index = 33;
      break;
    case '/services/pretaxdec':
      index = 34;
      break;
    case '/services/prefinadmfin':
      index = 35;
      break;
    case '/services/civilservices':
      index = 36;
      break;
    case '/services/appDev':
      index = 37;
      break;
    case '/services/web':
      index = 38;
      break;
    case '/services/technicSupport':
      index = 39;
      break;
    case '/services/accountSys':
      index = 40;
      break;
    case '/services/hr':
      index = 41;
      break;
    case '/services/AdminSystem':
      index = 42;
      break;
    case '/services/crm':
      index = 43;
    case '/services/patent':
      index = 44;
      break;
    case '/services/indusproduct':
      index = 45;
      break;
    case '/services/indusproduct':
      index = 46;
      break;
    case '/services/copyright':
      index = 47;
      break;
  }
  return (
    <>
      <HeaderServices />
      <div style={{ marginRight: '10px' }}>
        <Outlet />
      </div>
      <div className={styles.orderService}>
        <h5>لطلب خدمة عن طريق الزر ادناه</h5>
        {index !== -1 && (
          <Link
            to={`https://wa.me/${data[index].number}?text=${encodeURIComponent(data[index].whatsapp)}`}
            className={styles.icon}
          >
            <img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
            اطلب الخدمة
          </Link>
        )}
      </div>
    </>
  )
}

export default ServicesOf

//this is page services of services